import type { RouteDataFunc } from "@solidjs/router";
import { getUserStore } from "~/solidJs/entities/HeaderMain/models";
import type { IUser } from "~/solidJs/shared/helpers/types";
import { getUserAndSetStore, isUserInited } from "~/solidJs/shared/helpers/userHelpers";
import { AppSumoApi } from "../[AppSumoCallbackPage]/data";

const updateStoreIfNeedToRegister = async (user: IUser | null) => {
	const ok = await AppSumoApi.registerAppSumoCode();
	if (ok) {
		return await getUserAndSetStore();
	}
	return user;
};

export const getUser = async () => {
	let user = getUserStore();
	if (isUserInited(user)) {
		return updateStoreIfNeedToRegister(user);
	}
	user = await getUserAndSetStore();
	if (user) {
		return updateStoreIfNeedToRegister(user);
	}
	return user;
};

export const IndexLayoutData: RouteDataFunc = (_props) => {
	return { user: getUser() };
};
